import logo from '../../assets/cvlogo.png';
import './AppHome.css';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import EnvPanel from '../EnvPanel/EnvPanel.component';
import React from 'react';
import { EnvContext } from '../../contexts/environment.context';
import StatusBar from '../StatusBar/StatusBar.component';
import { environmentList } from '../../config/environment.config';
import { selectCurrentUser } from '../../store/user/user.selector';

const AppHome = () => {

  const { selectedEnvironment, setSelectedEnvironment } = useContext(EnvContext);
  const [data, setData] = React.useState(null);
  const currentUser = useSelector(selectCurrentUser);

  const environmentLabel = selectedEnvironment ? selectedEnvironment : " (Select Environment)"

  React.useEffect(() => {

    const { urlcontext } = {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      //mode: '*cors', // no-cors, *cors, same-origin
      //cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      //credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/xml',
        'Access-Control-Allow-Origin': '*', 
        'Access-Control-Allow-Credentials': true 
      },
      //redirect: 'follow', // manual, *follow, error
      //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //body: JSON.stringify('') // body data type must match "Content-Type" header
    };
    fetch('/api', urlcontext)
      .then((response) => response.json())
      .then(data => {
        setData(data.message)      });
  },[]);

  const onClickEnvButton = async (envcode) => {
    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
    console.log('onClickEnvButton Data: %s', envcode);}
    await setSelectedEnvironment(envcode);
  };

  
  React.useEffect(() => {
    if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
    console.log('Environment Code: %s', selectedEnvironment);}
  },[selectedEnvironment]);

  return(

    <div className="AppHome">
    <header className="AppHome-header">
      <StatusBar statusText={data} />
      <p>
        Clearview Environment Self-Service Portal {environmentLabel}
      </p>
      <img src={logo} className="AppHome-logo" alt="logo" />
      {
        currentUser ? (
        environmentList.map((envcode) => {
          if(process.env.REACT_APP_LOGGING_LEVEL !== '0') {
          console.log('Mapping environment code: %s', envcode.code);}
          return <button key={envcode.code} onClick={() => onClickEnvButton(envcode.code)}>{envcode.code}</button>
        }) ) : ( <p>Authenticating ....</p>
        )
        
      }
      <a
        className="AppHome-link"
        href="https://confluence.equisoft.com/display/CLEARVIEWILLUSTRATEAPPLYPORTALOIPAIMPLENTATION/CV+Environment+Management"
        target="_blank"
        rel="noopener noreferrer"
      >
        Clearview Environment Management Documentation
      </a>
    </header>
    <div>
      <EnvPanel envCode={selectedEnvironment} />
    </div>
  </div>
  );
}

export default AppHome;
